$(window).on('load scroll', function() {
  //ウインドウ下から50pxで.is-inview付与
  const windowHeight = $(window).height();
  const scrollTop = $(window).scrollTop();
  const windowBottom = $(window).scrollTop() + windowHeight;
  $('.toys-section-header, .js-toys-inview').each(function() {
    if ($(this).offset().top < windowBottom - 50) {
      $(this).addClass('is-inview');
    }
  });

  // CVボタンの表示切替
  var cvButton = $('.toys-cv-button');
  var startHeight = $('.toys-start').outerHeight();
  var footerHeight = $('.toys-footer').outerHeight();
  if (scrollTop >= windowHeight && scrollTop < document.body.offsetHeight - windowHeight - startHeight - footerHeight) {
    cvButton.addClass('is-show');
  } else {
    cvButton.removeClass('is-show');
  }
});


$(window).on('load', function () {
  //見出しアニメーション用spanタグ追加
  $(".toys-section-header__heading").each(function () {
    var $heading = $(this);
    var text = $heading.html().replace(/&amp;/g, '&');
    var textbox = "";
    var lines = text.split(/(<br.*?>|<[^>]+>|>)/); // <br>タグとタグ内の要素（<span>やその他のタグ）と>で分割
    var currentDelay = 0; // 現在のanimation-delayの値を保持する変数

    lines.forEach(function (line) {
      if (line.includes("<br") || line.includes("<") || line.includes(">")) {
        textbox += line; // <br>タグやタグ内の要素（<span>など）はそのまま追加
        // animation-delayの値を引き継ぐ
        var match = line.match(/animation-delay:(.*?)[s;]/);
        if (match) {
          currentDelay = parseFloat(match[1]).toFixed(1); // 小数点を1桁に固定
        }
      } else {
        var characters = line.split("");
        characters.forEach(function (character) {
          if (character !== " ") {
            textbox += '<span class="toys-section-header__letter" style="animation-delay:' + currentDelay + 's;">' + character + '</span>';
            currentDelay = (parseFloat(currentDelay) + 0.1).toFixed(1); // 0.1秒ずつ遅延させる
          } else {
            textbox += " ";
          }
        });
      }
    });
    $heading.html(textbox);
  });

  //図形パララックス
  gsap.registerPlugin(ScrollTrigger);
  $(".js-toys-parallax").each(function () {
    var spans = $(this).find("span");
    spans.css("display", "block");
    spans.each(function () {
      var y = $(this).attr("data-y") || 80;
      gsap.to(this, {
        y: y,
        scrollTrigger: {
          trigger: this,
          start: "top 45%",
          end: "bottom top",
          scrub: true,
          //markers: true,
          toggleActions: "play none none reverse"
        }
      });
    });
  });

  //文字色変更
  $(".js-toy-scroll-font p").each(function() {
    var text = $(this).html();
    var textbox = "";
    var lines = text.split(/(<br>|<br class=['"]max-lg:hidden['"]>|<br class=['"]lg:hidden max-lg:!block['"]>)/);
    lines.forEach(function(line, index) {
      if (line.startsWith("<br")) {
        textbox += line;
      } else {
        var characters = line.split("");
        characters.forEach(function(character) {
          if (character !== " ") {
            textbox += '<span>' + character + '</span>';
          } else {
            textbox += " ";
          }
        });
      }
    });
    $(this).html(textbox);
  });
  gsap.set('.js-toy-scroll-font p span', {
    color: '#C9C3BC',
  });
  gsap.to('.js-toy-scroll-font p span', {
      scrollTrigger: {
          trigger: '.js-toy-scroll-font p',
          start: 'top bottom-=50%',
          end: 'bottom bottom-=50%',
          scrub: true,
          // markers: true,
      },
      color: 'rgb(var(--color-primary-text))',
      stagger: 0.2,
      ease: 'poser2.out',
  });
});

{
  const urlParams = new URLSearchParams(window.location.search);
  const rdCode = urlParams.get('rd_code');

  if (rdCode) {
    // rd_codeをクッキーに保存
    document.cookie = `rd_code=${rdCode}; domain=toysrenta.com; path=/; expires=Sun, 31 Dec 2023 23:59:59 GMT`;
  }
  console.log(rdCode);
  console.log(document.cookie);

  function getCookie(name) {
  const cookieName = `${name}=`;
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i];
    while (cookie.charAt(0) === ' ') {
      cookie = cookie.substring(1);
    }
    if (cookie.indexOf(cookieName) === 0) {
      return cookie.substring(cookieName.length, cookie.length);
    }
  }
  return null;
}

// rd_codeクッキーの値を取得
const rdCodeValue = getCookie('rd_code');

if (rdCodeValue) {
  // rd_codeの値が存在する場合の処理
  console.log(`rd_codeの値は: ${rdCodeValue}`);
} else {
  // rd_codeの値が存在しない場合の処理
  console.log('rd_codeはクッキーに保存されていません。');
}
}
